<template>
  <div class="client-comment-block">
    <div class="client-comment-block__title">
      {{$t(`userNotes_Comments.localization_value.value`)}}
    </div>

    <template v-if="clientComments.getLastComment()">
      <div class="client-comment-block__list" @click="isModalClientCommentsPopup = true">
        <div class="client-comment-block__item"
             v-for="(item, index) in paginatedComments"
             :key="index"
        >
          <div class="client-comment-block__category" v-if="item.category">
            {{ item.category }}
          </div>
          <div class="client-comment-block__txt">
            {{ item.comment }}
          </div>
          <div class="client-comment-block__date">
            <template v-if="item.author">{{ item.author.email }} · </template>
            {{ item.created_at | moment('MMM DD, YYYY') }}
          </div>
        </div>
      </div>

      <div class="client-comment-block__bottom d-flex flex-wrap">
        <router-link :to="$store.getters.GET_PATHS.notes + `?userId=${clientComments.getUserId()}` +
                        (clientComments.getUserName() ? `&userName=${clientComments.getUserName()}` : '')" target="_blank">
          <MainButton
                  class="client-comment-block__btn btn-fit-content"
                  :value="$t('common_showMore.localization_value.value')"
          />
        </router-link>

        <Pagination
                v-if="clientComments.getCount() > perPage"
                class="client-comment-block__pagination"
                :count="clientComments.getCount()"
                :perPage="perPage"
                :page="currentPage"
                @paginate="(page) => currentPage = page"
        />
      </div>
    </template>

    <div v-else
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['consolidations_addComment'])"></div>
      <MainButton
              class="client-comment-block__btn btn-fit-content"
              :value="$t('consolidations_addComment.localization_value.value')"
              @click.native="isModalClientCommentsPopup = true"
      />
    </div>

    <ClientCommentsPopup
            v-if="isModalClientCommentsPopup"
            :clientComments="clientComments"
            @close="isModalClientCommentsPopup = false"
    />
  </div>
</template>

<script>
  import MainButton from "../../UI/buttons/MainButton/MainButton";
  import ClientCommentsPopup from "../Popups/ClientCommentsPopup/ClientCommentsPopup";
  import Pagination from "../Pagination/Pagination";

  export default {
    name: "ClientCommentBlock",
    components: {
      MainButton,
      ClientCommentsPopup,
      Pagination,
    },

    props: {
      clientComments: Object,
    },

    data() {
      return {
        isModalClientCommentsPopup: false,
        perPage: 3,
        currentPage: 1,
      }
    },

    computed: {
      paginatedComments() {
        let start = (this.currentPage - 1) * this.perPage
        return this.clientComments.getComments().slice(start, start + this.perPage)
      },
    },

    watch: {
      'clientComments.data.comments.length'(newLength) {
        let pageCount = Math.max(Math.ceil(newLength / this.perPage), 1)
        if (this.currentPage > pageCount) {
          this.currentPage = pageCount
        }
      },
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .client-comment-block{

    &__title{
      font-size: 18px;
      line-height: 21px;
      font-weight: 500;
      color: $black;
      padding-bottom: 8px;
      border-bottom: 1px solid $borderBrown;
    }

    &__list{
      cursor: pointer;
    }

    &__item{
      padding: 12px 0;
      border-bottom: 1px solid $borderBrownOpacity04;
    }

    &__category{
      font-size: 14px;
      line-height: 16px;
      font-weight: bold;
      color: $black;
      margin-bottom: 4px;
    }

    &__txt{
      font-size: 14px;
      line-height: 16px;
      color: $black;
      margin-bottom: 4px;
      white-space: pre-line;
      word-break: break-word;
    }

    &__date{
      font-size: 13px;
      line-height: 15px;
      color: $borderBrown;
      word-break: break-word;
    }

    &__btn{
      margin-top: 12px;
    }

    &__bottom{
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }

    & &__pagination{
      margin-top: 12px;

      .pagination__item{
        width: 28px;
        height: 24px;
        font-size: 12px;
        line-height: 24px;
      }
    }
  }

</style>
